import i18n from '@/i18n';
const configFormDomain = () => {
    return {
        configFieldTitle: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: '表示名',
            valueSync: '',
            typesValidate: ['max60', 'required']
        },
        configFieldDomain: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: 'ドメイン',
            valueSync: '',
            typesValidate: ['max60', 'required', 'domain']
        },
        configFieldSearchDomain: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: '',
            valueSync: '',
            typesValidate: []
        }
    };
};
const configFormCustomDomain = () => {
    return {
        configFieldDomain: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: 'ドメイン',
            valueSync: '',
            typesValidate: ['max60', 'required', 'domain']
        },
        configFieldSslType: {
            error: false,
            errorCustomMess: '',
            errorField: 'SSL種類',
            valueSync: 'AWS',
            typesValidate: ['required']
        },
        configFieldCertificateFile: {
            error: false,
            errorCustomMess: '',
            errorField: '証明書',
            valueSync: null,
            typesValidate: []
        },
        configFieldPrivateKeyFile: {
            error: false,
            errorCustomMess: '',
            errorField: '秘密鍵',
            valueSync: null,
            typesValidate: []
        },
        configFieldCertificateChainFile: {
            error: false,
            errorCustomMess: '',
            errorField: '証明書チェーン',
            valueSync: null,
            typesValidate: []
        }
    };
};
const configFormEmail = () => {
    return {
        configFieldTitle: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: '名前',
            valueSync: '',
            typesValidate: ['max60', 'required']
        },
        configFieldEmail: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.email'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['email', 'max60', 'required']
        },
        configFieldComment: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: 'コメント',
            valueSync: '',
            typesValidate: ['max60']
        }
    };
};
const configs = {
    configTableEmailSetting: {
        headers: [
            {
                label: 'メールアドレス'
            },
            {
                label: '名前'
            },
            {
                label: 'コメント'
            },
            {
                label: 'コマンド'
            }
        ]
    },
    configTableDomainSetting: {
        headers: [
            {
                label: 'ID'
            },
            {
                label: i18n.t('managerForm.email.title')
            },
            {
                label: i18n.t('managerForm.email.domain')
            },
            {
                label: i18n.t('managerForm.email.status')
            },
            {
                label: '作成日'
            },
            {
                label: 'コマンド'
            }
        ]
    },
    configTableCustomDomainSetting: {
        headers: [
            {
                label: 'ID'
            },
            {
                label: i18n.t('managerForm.email.domain')
            },
            {
                label: i18n.t('managerForm.email.status')
            },
            {
                label: '作成日'
            },
            {
                label: 'コマンド'
            }
        ]
    },
    configModalDomainDetail: {
        title: i18n.t('btn.detail'),
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        size: 'xl'
    },
    configModalDomainEdit: {
        title: i18n.t('btn.edit'),
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configKeyword: {
        arrayTag: [],
        placeholder: 'ドメイン',
        isShowLable: true
    },
    configPage: {
        total: 0,
        limit: 10,
        page: 1
    }
};

const STATUS_MAIL = [
    {
        value: 'Pending',
        label: '保留中',
        backgroundColor: '#fea217'
    },
    {
        value: 'Success',
        label: '成功',
        backgroundColor: '#1cbb8c'
    },
    {
        value: 'Failed',
        label: '失敗',
        backgroundColor: '#ea4335'
    }
];
const STATUS_DOMAIN = [
    {
        value: 'INITIALIZING',
        label: '初期化中',
        backgroundColor: '#74788d'
    },
    {
        value: 'PENDING_DNS',
        label: 'DNS確認中',
        backgroundColor: '#5b8dee'
    },
    {
        value: 'ACTIVE',
        label: '有効',
        backgroundColor: '#1cbb8c'
    },
    {
        value: 'FAILED',
        label: '失敗',
        backgroundColor: '#ea4335'
    },
    {
        value: 'EXPIRED',
        label: '期限切れ',
        backgroundColor: '#fea217'
    },
    {
        value: 'PENDING_SSL_VALIDATION',
        label: 'SSL確認中',
        backgroundColor: '#5b8dee'
    }
];
const initFormSearch = () => {
    return {
        domain: null,
        status: null
    };
};

export { configFormEmail, configFormDomain, configFormCustomDomain, configs, STATUS_MAIL, STATUS_DOMAIN, initFormSearch };
